import type { OfferImage } from '../types/offers'

/**
 * Generation widths for each offer image variant. Must match VARIANTS in
 * apps/api/src/merchant/offer-images.controller.ts — the actual sharp resize
 * targets used when the files are generated. sharp uses fit:'inside' with
 * withoutEnlargement, so a variant's real width can be smaller than this for
 * small source images, but never larger — these are the correct `w` descriptors.
 */
const VARIANT_WIDTHS = { sm: 200, md: 800, lg: 1600 } as const

export function buildOfferImageSrcSet(image: OfferImage): string {
  return `${image.sm} ${VARIANT_WIDTHS.sm}w, ${image.md} ${VARIANT_WIDTHS.md}w, ${image.lg} ${VARIANT_WIDTHS.lg}w`
}
